import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import MenuItem from '@material-ui/core/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Divider from '@material-ui/core/Divider';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Button as ButtonPrime } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { isBefore, isAfter, differenceInDays, differenceInHours, format } from 'date-fns';
import { Dialog as DialogPrime } from 'primereact/dialog';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { FaWindowClose, FaSpinner } from 'react-icons/fa';
import Chip from '@material-ui/core/Chip';
import CancelIcon from '@material-ui/icons/Cancel';
import { dominioDemandaCirurgica } from '../../config/database';
import 'assets/css/geral.css';
import { PendenciasWizard, setPendencia } from './ValidacaoWizard';

class DadosSolicitacao extends Component {
  state = {
    carater: null,
    dataSugerida: null,
    centroCirurgico: null,
    lateralidade: '',
    indicacaoClinica: null,
    prioridade: null,
    cidPrincipal: null,
    cidsSecundarios: [],
    tipoAcomodacao: null,
    dataInternacao: null,
    motivoAntecipacaoInternacao: null,
    modalidadeAtendimento: null,
    leitoUTI: false,
    tipoAnestesia: null,
    listaCarater: [],
    listaCentoCirurgico: [],
    listaPrioridade: [],
    listaCid: [],
    listaTipoAnestesia: [],
    listaTipoAcomodacao: [],
    listaMotivosAntecipacaoInternacao: [],
    listaModalidadeAtendimento: [],
    slaCaraterUrgencia: null,
    slacaraterEletivo: null,
    caraterUrgencia: null,
    caraterEletivo: null,
    avaliacaoAnestesica: false,
    motivoAvaliacaoAnestesica: null,
    internacao: null,
    listaProfissional: [],
    profissionalResponsavel: null,
    bloqueiaSelecionarResponsavel: false,
    bloqueioRecursoSistemaInternacaoPedidoCirurgia: false,
    bloqueioRecursoSistemaAvaliacaoAnestesicaPedidoCirurgia: false,
    configuracoesRecursoSistema: null,
    listaProcedimentoPrincipal: [],
    procedimentoPrincipal: null,
    procedimentosSecundarios: [],
    pedidosCirurgiaPacienteProcedimento: [],
    abrePedidoCirurgiaPacienteProcedimento: false,
    duracaoEstimada: null,
    listaProcedimentoSecundario: [],
    handleFuncaoQuantidadeItem: undefined,
    openModal: false,
    codigoProcedimentoSequencial: '041502',
    diariaPrevistaDesabilitada: false,
    diariasPrevistas: null,
    continuaProcedimentoDuplicado: false,
    duracaoEstimadaDesabilitada: false,
  };

  sugerirDiariasPrevistas = procedimentoPrincipalStorage => {
    let procedimentoPrincipal = null;

    if (procedimentoPrincipalStorage)
      procedimentoPrincipal = JSON.parse(procedimentoPrincipalStorage);
    else procedimentoPrincipal = this.state.procedimentoPrincipal;

    let tempoProcedimentoPrincipal = 0;
    if (procedimentoPrincipal) tempoProcedimentoPrincipal = procedimentoPrincipal.tempo;
    let maiorTempoProcedimentoSecundario = 0;
    if (this.state.procedimentosSecundarios.length > 0)
      maiorTempoProcedimentoSecundario = this.state.procedimentosSecundarios.reduce(
        (a, b) => (b.tempo > a.tempo ? b.y : a),
        this.state.procedimentosSecundarios[0].tempo
      );

    const maiorValor = Math.max(tempoProcedimentoPrincipal, maiorTempoProcedimentoSecundario);

    this.setState({ diariasPrevistas: maiorValor });
    localStorage.setItem('diariasPrevistas', maiorValor);
    setPendencia(1, PendenciasWizard.diariasPrevistas);
  };

  verificaProcedimentoInclusoCampanhaAtiva = idProcedimento => {
    return Promise.resolve(
      dominioDemandaCirurgica
        .get(`/api/verificarProcedimentoValidoCampanhaVigente/${idProcedimento}`)
        .then(res => {
          if (res.data.length > 0) {
            this.showWarn(
              `O procedimento selecionado faz parte da campanha ${res.data.join(
                ', '
              )} e deve ser selecionado o modelo referente a esta campanha.`,
              'warn'
            );
            return true;
          }
          return false;
        })
    );
  };

  colocaQuantidadeProcedimentoPrincipal = () => {
    this.setState({ duracaoEstimada: '' });
    localStorage.removeItem('duracaoEstimada');
    this.setOpenModal(this.handleConfirmaQuantidadeProcPrin);
    setPendencia(1, PendenciasWizard.procedimentoPrincipal);
  };

  carregarPedidosCirurgiaPacienteProcedimento = idProcedimento => {
    const novoPaciente = JSON.parse(localStorage.getItem('novoPaciente'));

    if (novoPaciente) {
      this.colocaQuantidadeProcedimentoPrincipal();
      return;
    }

    const paciente = JSON.parse(localStorage.getItem('paciente'));

    dominioDemandaCirurgica
      .get(`/api/pedidoCirurgiaPacienteProcedimento/${paciente.SEQ_PACIENTE}/${idProcedimento}`)
      .then(res => {
        if (res.data.length > 0)
          this.setState({
            pedidosCirurgiaPacienteProcedimento: res.data,
            abrePedidoCirurgiaPacienteProcedimento: true,
          });
        else {
          this.colocaQuantidadeProcedimentoPrincipal();
        }
      });
  };

  setProcSec = proc => {
    this.setState({ procedimentosSecundarios: proc });
  };

  setOpenModal = functionQuantidade => {
    this.setState({ handleFuncaoQuantidadeItem: functionQuantidade });
    this.setState({ openModal: true });
  };

  setCloseModal = () => {
    this.setState({ openModal: false });
    this.limpaItensSemQuantidade();
  };

  setQuantidade = () => {
    const quantidade = document.getElementById('quantidade');
    this.state.handleFuncaoQuantidadeItem(quantidade.value);
    quantidade.value = '';
    this.setCloseModal();
  };

  handleConfirmaQuantidadeProcSec = async quantidade => {
    const lista = this.state.procedimentosSecundarios;
    const duracaoEstimadaAux = localStorage.getItem('duracaoEstimada');
    if (duracaoEstimadaAux.length > 0) {
      Number(duracaoEstimadaAux);
    }

    lista[lista.length - 1].quantidade = quantidade;

    const duracaoProcSecSemDuracao = 120 * quantidade;
    const duracaoProcSecComDuracao = lista[lista.length - 1]?.duracao * quantidade;

    if (lista[lista.length - 1].duracao === 0 || lista[lista.length - 1].duracao === null) {
      await this.setState(prevState => ({
        duracaoEstimada: Number(prevState.duracaoEstimada) + duracaoProcSecSemDuracao,
      }));
    } else {
      await this.setState(prevState => ({
        duracaoEstimada: Number(prevState.duracaoEstimada) + duracaoProcSecComDuracao,
      }));
    }

    localStorage.setItem('duracaoEstimada', Number(this.state.duracaoEstimada));
    localStorage.setItem('procedimentosSecundarios', JSON.stringify(lista));

    this.setCloseModal();
    this.sugerirDiariasPrevistas();
  };

  renderTagProcSec = () => {
    return this.state.procedimentosSecundarios.map(proc => {
      const label = `${proc.descricao} x${proc.quantidade}` || proc;
      return (
        <Chip
          key={label}
          label={label}
          deleteIcon={<CancelIcon />}
          className="div-chip wrap-chip"
          onDelete={() => {
            const lista = this.state.procedimentosSecundarios.filter(entry => entry !== proc);
            this.setProcSec(lista);
            localStorage.setItem('procedimentosSecundarios', JSON.stringify(lista));
            const duracaoProcedimentoTotal = proc?.duracao * parseInt(proc.quantidade, 10);
            const duracaoProcedimentoAux = this.state.duracaoEstimada;

            if (proc.duracao === 0 || proc.duracao === null) {
              this.setState({
                duracaoEstimada: duracaoProcedimentoAux - 120,
              });
              localStorage.setItem('duracaoEstimada', duracaoProcedimentoAux - 120);
            } else {
              this.setState({
                duracaoEstimada: duracaoProcedimentoAux - duracaoProcedimentoTotal,
              });
              localStorage.setItem(
                'duracaoEstimada',
                duracaoProcedimentoAux - duracaoProcedimentoTotal
              );
            }
          }}
        />
      );
    });
  };

  handleConfirmaQuantidadeProcPrin = quantidade => {
    const proc = this.state.procedimentoPrincipal;
    const duracaoEstimadaAux = this.state.duracaoEstimada;

    proc.quantidade = quantidade;

    localStorage.setItem('procedimentoPrincipal', JSON.stringify(proc));

    this.setState({
      duracaoEstimada: duracaoEstimadaAux + this.state.procedimentoPrincipal?.duracao * quantidade,
    });
    localStorage.setItem(
      'duracaoEstimada',
      duracaoEstimadaAux + this.state.procedimentoPrincipal?.duracao * quantidade
    );

    this.setCloseModal();
    this.sugerirDiariasPrevistas();
  };

  limpaItensSemQuantidade = () => {
    let lista = [];
    /*
    //  Caixas OPME
    lista = this.state.caixasOPME.filter(caixa => {
      return caixa.quantidade !== 0 && caixa.quantidade > 0;
    });

    this.setState({ caixasOPME: lista });
    localStorage.setItem('caixasOPME', JSON.stringify(lista));

    // Materiais consumíveis
    lista = this.state.materiaisConsumiveis.filter(material => {
      return material.quantidade !== 0 && material.quantidade > 0;
    });

    this.setState({ materiaisConsumiveis: lista });
    localStorage.setItem('materiaisConsumiveis', JSON.stringify(lista));

    //  Hemoderivados
    lista = this.state.hemoderivados.filter(hemoderivado => {
      return hemoderivado.quantidade !== 0 && hemoderivado.quantidade > 0;
    });

    this.setState({ hemoderivados: lista });
    localStorage.setItem('hemoderivados', JSON.stringify(lista));

    */

    //  Procedimento Principal
    if (this.state.procedimentoPrincipal && this.state.procedimentoPrincipal.quantidade < 1) {
      this.setState({ procedimentoPrincipal: null });
    }

    //  Procedimentos Secundários
    lista = this.state.procedimentosSecundarios.filter(proc => {
      return proc.quantidade !== 0 && proc.quantidade > 0;
    });

    this.setState({ procedimentosSecundarios: lista });
    localStorage.setItem('procedimentosSecundarios', JSON.stringify(lista));
  };

  alimentarStates = () => {
    const carater = localStorage.getItem('carater');
    const profissionalResponsavel = localStorage.getItem('profissionalResponsavel');
    // const dataSugeridaTZ = localStorage.getItem('dataSugerida').split('-');
    // const dataSugerida = `${dataSugeridaTZ[0]}-${dataSugeridaTZ[1]}-${dataSugeridaTZ[2]}`;
    const dataSugerida = localStorage.getItem('dataSugerida');
    const centroCirurgico = localStorage.getItem('centroCirurgico');
    const lateralidade = localStorage.getItem('lateralidade');
    const indicacaoClinica = localStorage.getItem('indicacaoClinica');
    const prioridade = localStorage.getItem('prioridade');
    const cidPrincipal = localStorage.getItem('cidPrincipal');
    const cidsSecundarios = localStorage.getItem('cidsSecundarios');
    const tipoAcomodacao = localStorage.getItem('tipoAcomodacao');
    const leitoUTI = localStorage.getItem('leitoUTI');
    const tipoAnestesia = localStorage.getItem('tipoAnestesia');
    const dataInternacao = localStorage.getItem('dataInternacao');
    const motivoAntecipacaoInternacao = localStorage.getItem('motivoAntecipacaoInternacao');
    const internacao = localStorage.getItem('internacao');
    const modalidadeAtendimento = localStorage.getItem('modalidadeAtendimento');
    const listaModalidadeAtendimento = localStorage.getItem('listaModalidadeAtendimento');
    const diariasPrevistas = localStorage.getItem('diariasPrevistas');
    const procedimentoPrincipal = localStorage.getItem('procedimentoPrincipal');
    const procedimentosSecundarios = localStorage.getItem('procedimentosSecundarios');
    const diariasPrevistasMinima = localStorage.getItem('diariasPrevistasMinima');
    const diariasPrevistasMaxima = localStorage.getItem('diariasPrevistasMaxima');
    const duracaoEstimada = localStorage.getItem('duracaoEstimada');
    const duracaoEstimadaMinimaPermitida = localStorage.getItem('duracaoEstimadaMinimaPermitida');
    const duracaoEstimadaMaximaPermitida = localStorage.getItem('duracaoEstimadaMaximaPermitida');

    if (duracaoEstimada) {
      this.setState({ duracaoEstimada });
      setPendencia(1, PendenciasWizard.duracaoEstimada);
    }
    if (
      duracaoEstimadaMinimaPermitida &&
      duracaoEstimadaMaximaPermitida &&
      duracaoEstimadaMinimaPermitida === duracaoEstimadaMaximaPermitida
    ) {
      this.setState({
        duracaoEstimada: duracaoEstimadaMinimaPermitida,
        duracaoEstimadaDesabilitada: true,
      });
      localStorage.setItem('duracaoEstimada', duracaoEstimadaMinimaPermitida);
      setPendencia(1, PendenciasWizard.duracaoEstimada);
    }
    if (procedimentoPrincipal) {
      this.setState({ procedimentoPrincipal: JSON.parse(procedimentoPrincipal) });
      setPendencia(1, PendenciasWizard.procedimentoPrincipal);
      if (!diariasPrevistas) {
        this.sugerirDiariasPrevistas(procedimentoPrincipal);
      }
    }
    if (procedimentosSecundarios) {
      this.setState({ procedimentosSecundarios: JSON.parse(procedimentosSecundarios) });
    }
    if (carater) this.setState({ carater: JSON.parse(carater) });
    if (profissionalResponsavel)
      this.setState({ profissionalResponsavel: JSON.parse(profissionalResponsavel) });
    if (dataSugerida) this.setState({ dataSugerida });
    if (centroCirurgico) this.setState({ centroCirurgico: JSON.parse(centroCirurgico) });
    if (lateralidade) this.setState({ lateralidade });
    if (indicacaoClinica) this.setState({ indicacaoClinica });
    if (prioridade) this.setState({ prioridade: JSON.parse(prioridade) });
    if (cidPrincipal) this.setState({ cidPrincipal: JSON.parse(cidPrincipal) });
    if (cidsSecundarios) this.setState({ cidsSecundarios: JSON.parse(cidsSecundarios) });
    if (tipoAcomodacao) this.setState({ tipoAcomodacao: JSON.parse(tipoAcomodacao) });
    if (leitoUTI) this.setState({ leitoUTI: leitoUTI === 'true' });
    if (tipoAnestesia) this.setState({ tipoAnestesia: JSON.parse(tipoAnestesia) });
    if (motivoAntecipacaoInternacao) {
      this.setState({ motivoAntecipacaoInternacao: JSON.parse(motivoAntecipacaoInternacao) });
    }
    if (internacao) {
      this.setState({ internacao: JSON.parse(internacao) });
    }
    if (listaModalidadeAtendimento) {
      this.setState({ listaModalidadeAtendimento: JSON.parse(listaModalidadeAtendimento) });
    }
    if (modalidadeAtendimento) {
      setPendencia(1, PendenciasWizard.modalidadeAtendimento);
      this.handleAlteracaoModalidadeAtendimento(JSON.parse(modalidadeAtendimento));
    }
    /* if (dataInternacao) {
      const data = new Date(dataInternacao.substring(0, 11));
      data.setHours(data.getHours() + 3);
      data.setDate(data.getDate() - 1);
      this.setState({ dataInternacao: this.formatDate(data) });
      localStorage.setItem('dataInternacao', dataInternacao);
    } */
    if (diariasPrevistas) {
      this.setState({ diariasPrevistas });
      setPendencia(1, PendenciasWizard.diariasPrevistas);
    } else if (!diariasPrevistasMinima && !diariasPrevistasMaxima) {
      this.sugerirDiariasPrevistas(procedimentoPrincipal);
    }
  };

  componentDidMount() {
    this.alimentarStates();

    const procedimentoPrincipalPermitido = JSON.parse(
      localStorage.getItem('procedimentoPrincipalPermitido')
    );
    if (procedimentoPrincipalPermitido)
      this.setState({ listaProcedimentoPrincipal: procedimentoPrincipalPermitido });
    else
      dominioDemandaCirurgica.get('/api/procedimentoCirurgico').then(response => {
        this.setState({ listaProcedimentoPrincipal: response.data });
      });

    const procedimentoSecundarioPermitido = JSON.parse(
      localStorage.getItem('procedimentoSecundarioPermitido')
    );
    if (procedimentoSecundarioPermitido)
      this.setState({ listaProcedimentoSecundario: procedimentoSecundarioPermitido });
    else
      dominioDemandaCirurgica.get('/api/procedimentoCirurgico').then(response => {
        this.setState({ listaProcedimentoSecundario: response.data });
      });

    const { statusInicial, caraterUrgencia, caraterEletivo } = JSON.parse(
      localStorage.getItem('configuracoes')
    );

    this.setState({
      caraterUrgencia,
      caraterEletivo,
    });

    dominioDemandaCirurgica.get(`/api/statusPedidoDetail/${statusInicial}`).then(response => {
      this.setState({
        slaCaraterUrgencia: response.data.prazoLimiteSLAUrgencia,
        slacaraterEletivo: response.data.prazoLimiteSLAEletivo,
      });
    });

    dominioDemandaCirurgica.get('/api/caraterAtendimento').then(response => {
      this.setState({ listaCarater: response.data });
    });

    const profissionalGerente = JSON.parse(localStorage.getItem('profissional'));
    const centrosCirurgicosProfissional = profissionalGerente?.centrosCirurgicos ?? [];

    dominioDemandaCirurgica.get('/api/centroCirurgico').then(response => {
      this.setState({ listaCentoCirurgico: response.data.filter(item => centrosCirurgicosProfissional.includes(item.id)) });
    });

    dominioDemandaCirurgica.get('/api/prioridadeCirurgia').then(response => {
      this.setState({ listaPrioridade: response.data });
    });

    dominioDemandaCirurgica.get('/api/cid').then(response => {
      this.setState({ listaCid: response.data });
    });

    dominioDemandaCirurgica.get('/api/tipoAnestesia').then(response => {
      this.setState({ listaTipoAnestesia: response.data });
    });

    dominioDemandaCirurgica.get('/api/tipoAcomodacao').then(response => {
      this.setState({ listaTipoAcomodacao: response.data });
    });

    dominioDemandaCirurgica.get('/api/motivoAntecipacaoInternacao').then(response => {
      this.setState({ listaMotivosAntecipacaoInternacao: response.data });
    });

    const profissional = JSON.parse(localStorage.getItem('profissionalRequisitante'));

    if (profissional.residente)
      dominioDemandaCirurgica
        .get(`/api/listarProfissionalResponsavel/${profissional.id}`)
        .then(response => {
          this.setState({ listaProfissional: response.data });
        });
    else {
      const profissionalResponsavel = {
        id: profissional.id,
        crm: profissional.crm,
        nome: profissional.nome,
      };

      this.setState({
        profissionalResponsavel,
      });

      localStorage.setItem('profissionalResponsavel', JSON.stringify(profissionalResponsavel));
      setPendencia(1, PendenciasWizard.profissionalResponsavel);
      this.setState({ bloqueiaSelecionarResponsavel: true });
    }
  }

  handleAlteracaoModalidadeAtendimento(modalidadeAtendimento) {
    if (!modalidadeAtendimento) return;

    const configuracoesRecursoSistema = JSON.parse(
      localStorage.getItem('configuracoesRecursoSistema')
    );

    const bloqueioInternacao = modalidadeAtendimento.recursosBloqueados.some(
      recursoBloqueado =>
        recursoBloqueado.id === configuracoesRecursoSistema.internacaoPedidoCirurgia
    );

    if (bloqueioInternacao) {
      this.setState({
        dataInternacao: '',
        motivoAntecipacaoInternacao: null,
        tipoAcomodacao: null,
        leitoUTI: false,
      });

      localStorage.removeItem('dataInternacao');
      localStorage.removeItem('motivoAntecipacaoInternacao');
      localStorage.removeItem('tipoAcomodacao');
      localStorage.removeItem('leitoUTI');
    } /* else if (this.state.internacao && this.state.internacao.dataInternacao) {
      const dataInternacaoString = this.state.internacao.dataInternacao.split('T')[0];
      localStorage.setItem('dataInternacao', dataInternacaoString);
      this.setState({ dataInternacao: dataInternacaoString });
    } else {
      const dataInternacao = new Date(this.state.dataSugerida);
      dataInternacao.setDate(dataInternacao.getDate() - 1);
      localStorage.setItem('dataInternacao', this.formatDate(dataInternacao));
      this.setState({ dataInternacao: this.formatDate(dataInternacao) });
    } */

    this.setState({
      bloqueioRecursoSistemaInternacaoPedidoCirurgia: bloqueioInternacao,
    });

    const bloqueioAvaliacaoAnestesica = modalidadeAtendimento.recursosBloqueados.some(
      recursoBloqueado =>
        recursoBloqueado.id === configuracoesRecursoSistema.avaliacaoAnestesicaPedidoCirurgia
    );

    this.setState({
      bloqueioRecursoSistemaAvaliacaoAnestesicaPedidoCirurgia: bloqueioAvaliacaoAnestesica,
    });

    localStorage.setItem('modalidadeAtendimento', JSON.stringify(modalidadeAtendimento));
    this.setState({ modalidadeAtendimento });
    setPendencia(1, PendenciasWizard.modalidadeAtendimento);
  }

  formatDate = date => {
    const d = new Date(date);
    d.setDate(d.getDate() + 1);
    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    const year = d.getFullYear();

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;

    return [year, month, day].join('-');
  };

  renderFooterDisplayErro = () => {
    return (
      <div>
        <ButtonPrime
          label="OK"
          icon="pi pi-check"
          onClick={() => this.setState({ dialogMotivo: false })}
          autoFocus
          disabled={this.state.motivoAntecipacaoInternacao === null}
        />
      </div>
    );
  };

  showWarn(msg, severity) {
    this.toast.show({
      severity,
      summary: 'Atenção!',
      detail: msg,
      life: 3000,
    });
  }

  render() {
    return (
      <Container>
        <Toast ref={el => (this.toast = el)} position="top-right" />
        <DialogPrime
          header="Aviso de Duplicidade"
          visible={this.state.abrePedidoCirurgiaPacienteProcedimento}
          style={{ width: '65vw' }}
          onHide={() => {
            if (!this.state.continuaProcedimentoDuplicado) {
              localStorage.removeItem('procedimentoPrincipal');
              this.setState({
                procedimentoPrincipal: null,
              });
            }
            this.setState({
              abrePedidoCirurgiaPacienteProcedimento: false,
              continuaProcedimentoDuplicado: false,
            });
            document.getElementById('procedimentoPrincipal').focus();
          }}
        >
          <strong>
            Atenção! Esse paciente já possui pedido de cirurgia para o procedimento selecionado.
          </strong>
          <br />
          <br />
          <div style={{ overflow: 'auto', height: '58vh' }}>
            {this.state.pedidosCirurgiaPacienteProcedimento.map(pedidoCirurgia => {
              const dataCirurgia = new Date(pedidoCirurgia.dataCirurgia.replace('Z', ''));
              const dataCirurgiaFormatada = format(dataCirurgia, 'dd/MM/yyyy HH:mm');

              const dataInclusao = new Date(pedidoCirurgia.dataInclusao.replace('Z', ''));
              const dataInclusaoFormatada = format(dataInclusao, 'dd/MM/yyyy HH:mm');

              return (
                <Card key={pedidoCirurgia.id}>
                  <CardHeader color="info" id="centroMeusPedidos">
                    <strong>{`Nº Pedido: ${pedidoCirurgia.codigo}`}</strong>
                  </CardHeader>
                  <CardBody>
                    <div className="row-resumo">
                      <span className="titulo-card">
                        <strong>Paciente:</strong>
                      </span>
                      <span>{pedidoCirurgia.paciente}</span>
                    </div>
                    <div className="row-resumo">
                      <span className="titulo-card">
                        <strong>Atendimento Origem:</strong>
                      </span>
                      <span>{pedidoCirurgia.atendimento}</span>
                    </div>
                    <div className="row-resumo">
                      <span className="titulo-card">
                        <strong>Requisitante:</strong>
                      </span>
                      <span>{pedidoCirurgia.profissionalRequisitante}</span>
                    </div>
                    <div className="row-resumo">
                      <span className="titulo-card">
                        <strong>Data da Solicitação:</strong>
                      </span>
                      <span>{dataInclusaoFormatada}</span>
                    </div>
                    <div className="row-resumo">
                      <span className="titulo-card">
                        <strong>Data da Cirurgia:</strong>
                      </span>
                      <span>{dataCirurgiaFormatada}</span>
                    </div>
                  </CardBody>
                </Card>
              );
            })}
          </div>
          <br />
          <div style={{ float: 'right' }}>
            <Button
              variant="contained"
              color="secondary"
              style={{ marginRight: '5px', marginBottom: '15px' }}
              onClick={() => {
                this.setState({
                  abrePedidoCirurgiaPacienteProcedimento: false,
                });
              }}
            >
              Cancelar
            </Button>
            <Button
              style={{ marginBottom: '15px' }}
              variant="contained"
              color="primary"
              onClick={() => {
                this.setState({
                  abrePedidoCirurgiaPacienteProcedimento: false,
                  continuaProcedimentoDuplicado: true,
                });
                this.colocaQuantidadeProcedimentoPrincipal();
              }}
            >
              Continuar
            </Button>
          </div>
        </DialogPrime>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={this.state.openModal}
          onClose={this.setCloseModal}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={this.state.openModal}>
            <div className="modal-quantidade">
              <button
                type="button"
                onClick={this.setCloseModal}
                style={{ float: 'right', cursor: 'pointer', background: 'none', border: 'none' }}
              >
                <FaWindowClose color="black" size={24} />
              </button>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <h3>Quantidade</h3>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    autoComplete="off"
                    name="quantidade"
                    variant="outlined"
                    type="number"
                    fullWidth
                    id="quantidade"
                    label="Quantidade"
                    style={{ marginBottom: '30px' }}
                    defaultValue={1}
                    onChange={e => {
                      if (e.target.value.length > 4) {
                        e.target.value = e.target.value.substring(0, 4);
                      }
                      if (e.target.value.toString().includes('-')) {
                        e.target.value = 1;
                      }
                      if (e.target.value === 0) {
                        e.target.value = 1;
                      }
                    }}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        this.setQuantidade();
                      }
                    }}
                    inputProps={{
                      min: 1,
                    }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ float: 'right' }}
                    onClick={this.setQuantidade}
                  >
                    Confirmar
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Fade>
        </Modal>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Procedimentos Cirúrgicos</h3>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id="procedimentoPrincipal"
              options={this.state.listaProcedimentoPrincipal}
              getOptionLabel={option =>
                `${option.descricao.trim()} x${option.quantidade} - ${option.duracao ?? 0} min.`
              }
              fullWidth
              value={this.state.procedimentoPrincipal}
              onChange={(e, value) => {
                const carater = JSON.parse(localStorage.getItem('carater'));
                const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));

                const idModeloPedidoCirurgia = JSON.parse(
                  localStorage.getItem('idModeloPedidoCirurgia')
                );
                const tipoPedido = JSON.parse(localStorage.getItem('tipoPedido'));

                if (value !== null) {
                  if (!idModeloPedidoCirurgia && carater.id === configuracoes.caraterEletivo) {
                    this.verificaProcedimentoInclusoCampanhaAtiva(value.id).then(data => {
                      if (data === false && tipoPedido === null) {
                        this.carregarPedidosCirurgiaPacienteProcedimento(value.id);
                        this.setState({ procedimentoPrincipal: value });
                      }
                      if (data === false && tipoPedido === 0) {
                        this.carregarPedidosCirurgiaPacienteProcedimento(value.id);
                        this.setState({ procedimentoPrincipal: value });
                      }
                      if (data === false && tipoPedido === 1) {
                        this.carregarPedidosCirurgiaPacienteProcedimento(value.id);
                        this.setState({ procedimentoPrincipal: value });
                      }
                      if (data && tipoPedido === 1) {
                        this.carregarPedidosCirurgiaPacienteProcedimento(value.id);
                        this.setState({ procedimentoPrincipal: value });
                      }
                    });
                  } else {
                    this.carregarPedidosCirurgiaPacienteProcedimento(value.id);
                    this.setState({ procedimentoPrincipal: value });
                  }
                } else {
                  this.setState({ procedimentoPrincipal: value });
                  this.setState({ procedimentosSecundarios: [] });
                  this.setState({ duracaoEstimada: '' });
                  localStorage.removeItem('procedimentoPrincipal');
                  localStorage.removeItem('duracaoEstimada');
                }
              }}
              renderInput={params => (
                <TextField {...params} label="Procedimento Principal" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              multiple
              id="procedimentosSecundarios"
              options={this.state.listaProcedimentoSecundario}
              getOptionLabel={option => `${option.descricao} - ${option.duracao} min.`}
              value={this.state.procedimentosSecundarios}
              renderTags={() => {}}
              closeIcon={false}
              onChange={(e, values) => {
                if (!this.state.procedimentoPrincipal) {
                  this.showWarn('Selecione um procedimento principal.', 'warn');
                } else {
                  this.setProcSec(values);
                  this.setOpenModal(this.handleConfirmaQuantidadeProcSec);
                }
              }}
              filterSelectedOptions
              renderInput={params => (
                <TextField {...params} variant="outlined" label="Procedimentos Secundários" />
              )}
            />
            <div className="chip">{this.renderTagProcSec()}</div>
            {this.state.codigoProcedimentoSequencial ===
              this.state.procedimentoPrincipal?.codigo.slice(0, 6) &&
              this.state.procedimentosSecundarios.length < 2 && (
                <Grid style={{ marginBottom: 12 }}>
                  <span className="comunicado-procedimento-sequencial">
                    Selecione no mínimo 2 procedimentos sequenciais
                  </span>
                </Grid>
              )}
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              InputLabelProps={{ shrink: true }}
              autoComplete="off"
              name="duracaoEstimada"
              type="number"
              variant="outlined"
              fullWidth
              id="duracaoEstimada"
              error={
                this.state.duracaoEstimada < 120 &&
                !this.state.procedimentoPrincipal?.duracao &&
                this.state.codigoProcedimentoSequencial !==
                  this.state.procedimentoPrincipal?.codigo.slice(0, 6)
              }
              helperText={
                this.state.duracaoEstimada < 120 &&
                !this.state.procedimentoPrincipal?.duracao &&
                this.state.codigoProcedimentoSequencial !==
                  this.state.procedimentoPrincipal?.codigo.slice(0, 6)
                  ? 'Você não pode fazer um pedido de cirurgia com duração abaixo de 120 minutos'
                  : ''
              }
              disabled={
                this.state.duracaoEstimadaDesabilitada ||
                this.state.procedimentoPrincipal?.duracao > 0 ||
                this.state.codigoProcedimentoSequencial ===
                  this.state.procedimentoPrincipal?.codigo.slice(0, 6)
              }
              label="Duração estimada (minutos)"
              value={this.state.duracaoEstimada}
              onChange={e => {
                if (e.target.value.toString().includes('-')) {
                  alert('Valor negativo não permitido');
                  e.target.value = 0;
                }
                if (e.target.value.length > 4) {
                  e.target.value = e.target.value.substring(0, 4);
                }

                localStorage.setItem('duracaoEstimada', e.target.value);
                this.setState({ duracaoEstimada: Number(e.target.value) });
                // setPendencia(1, PendenciasWizard.duracaoEstimada);
              }}
              InputProps={{
                inputProps: {
                  max: 100,
                  min: 0,
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              name="diariasPrevistas"
              variant="outlined"
              fullWidth
              id="diariasPrevistas"
              disabled={this.state.diariaPrevistaDesabilitada}
              label="Diárias Previstas"
              InputLabelProps={{ shrink: true }}
              type="number"
              value={this.state.diariasPrevistas}
              onChange={e => {
                if (e.target.value.toString().includes('-')) {
                  alert('Valor negativo não permitido');
                  e.target.value = '';
                }

                if (e.target.value.toString().length >= 3) {
                  alert('valor maximo:99');
                  e.target.value = '';
                }

                if (e.target.value.toString().includes(',')) {
                  alert('Valor decimal não permitido');
                  e.target.value = '';
                }
                if (e.target.value.toString().includes('.')) {
                  alert('Valor decimal não permitido');
                  e.target.value = '';
                }
                localStorage.setItem('diariasPrevistas', e.target.value);
                this.setState({ diariasPrevistas: e.target.value });
                setPendencia(1, PendenciasWizard.diariasPrevistas);
              }}
              InputProps={{
                inputProps: {
                  max: 100,
                  min: 0,
                },
                style: {
                  height: '52px',
                },
              }}
            />
          </Grid>
          {/* <Grid item xs={12} sm={5}>
            {this.renderComunicadoIntervaloCirurgia()}
            </Grid> */}
        </Grid>
        <br />
        <Divider />
        <br />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Dados da Solicitação</h3>
          </Grid>
          {/* <Grid item xs={12} sm={12}>
            <TextField
              autoComplete="off"
              type="datetime-local"
              name="dataSugerida"
              variant="outlined"
              fullWidth
              id="dataSugerida"
              label="Data Sugerida da Cirurgia"
              InputLabelProps={{ shrink: true }}
              value={this.state.dataSugerida}
              onChange={e => {
                if (this.state.carater) {
                  const dataSugerida = new Date(e.target.value);
                  const dataAtual = new Date();
                  let slaCarater = 0;
                  if (this.state.carater.id === this.state.caraterUrgencia) {
                    slaCarater = this.state.slaCaraterUrgencia;
                    if (differenceInHours(dataSugerida, dataAtual) > slaCarater) {
                      this.showWarn(
                        `Você não pode fazer um pedido de urgência/emergência acima de ${slaCarater} horas.`,
                        'warn'
                      );
                      document.getElementById('dataSugerida').value = '';
                      return;
                    }
                  } else if (this.state.carater.id === this.state.caraterEletivo) {
                    slaCarater = this.state.slacaraterEletivo;
                    if (differenceInDays(dataSugerida, dataAtual) < slaCarater) {
                      this.showWarn('Data selecionada está dentro do prazo mínimo do SLA.', 'warn');
                      document.getElementById('dataSugerida').value = '';
                      return;
                    }
                  }
                }
                localStorage.setItem('dataSugerida', e.target.value);
                this.setState({ dataSugerida: e.target.value });
                setPendencia(1, PendenciasWizard.dataSugerida);

                if (
                  !this.state.bloqueioRecursoSistemaInternacaoPedidoCirurgia &&
                  !this.state.internacao
                ) {
                  const dataInternacao = new Date(e.target.value);
                  dataInternacao.setDate(dataInternacao.getDate() - 1);
                  localStorage.setItem('dataInternacao', this.formatDate(dataInternacao));
                  this.setState({ dataInternacao: this.formatDate(dataInternacao) });
                }
              }}
            />
          </Grid> */}
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id="profissionalResponsavel"
              options={this.state.listaProfissional}
              getOptionLabel={option => `${option.crm} - ${option.nome}`}
              fullWidth
              disableClearable
              disabled={this.state.bloqueiaSelecionarResponsavel}
              value={this.state.profissionalResponsavel}
              onChange={(e, value) => {
                localStorage.setItem('profissionalResponsavel', JSON.stringify(value));
                this.setState({ profissionalResponsavel: value });
                setPendencia(1, PendenciasWizard.profissionalResponsavel);
              }}
              renderInput={params => (
                <TextField {...params} label="Responsável" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id="centroCirurgico"
              options={this.state.listaCentoCirurgico}
              getOptionLabel={option => `${option.descricao}`}
              fullWidth
              value={this.state.centroCirurgico}
              onChange={(e, values) => {
                if (values && this.state.carater) {
                  dominioDemandaCirurgica
                    .get(
                      `/api/modalidadesCentroCirurgicoCaraterAtendimento/${this.state.carater.id}/${values.id}`
                    )
                    .then(response => {
                      this.setState({
                        listaModalidadeAtendimento: response.data,
                        modalidadeAtendimento: response.data[0],
                      });

                      if (response.data[0])
                        this.handleAlteracaoModalidadeAtendimento(response.data[0]);

                      localStorage.setItem(
                        'listaModalidadeAtendimento',
                        JSON.stringify(response.data)
                      );
                    });
                }

                localStorage.setItem('centroCirurgico', JSON.stringify(values));
                this.setState({ centroCirurgico: values });

                if (localStorage.getItem('dataSugerida')) localStorage.removeItem('dataSugerida');

                setPendencia(1, PendenciasWizard.centroCirurgico);
              }}
              renderInput={params => (
                <TextField {...params} label="Centro Cirúrgico" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id="carater"
              options={this.state.listaCarater}
              getOptionLabel={option => `${option.descricao}`}
              fullWidth
              value={this.state.carater}
              onChange={(e, values) => {
                if (values && this.state.centroCirurgico) {
                  dominioDemandaCirurgica
                    .get(
                      `/api/modalidadesCentroCirurgicoCaraterAtendimento/${values.id}/${this.state.centroCirurgico.id}`
                    )
                    .then(response => {
                      this.setState({
                        listaModalidadeAtendimento: response.data,
                        modalidadeAtendimento: response.data[0],
                      });

                      if (response.data[0])
                        this.handleAlteracaoModalidadeAtendimento(response.data[0]);

                      localStorage.setItem(
                        'listaModalidadeAtendimento',
                        JSON.stringify(response.data)
                      );
                    });
                }

                if (this.state.dataSugerida && values) {
                  const dataSugerida = new Date(this.state.dataSugerida);
                  const dataAtual = new Date();
                  let slaCarater = 0;
                  if (values.id === this.state.caraterUrgencia) {
                    slaCarater = this.state.slaCaraterUrgencia;
                    if (differenceInHours(dataSugerida, dataAtual) > slaCarater) {
                      this.showWarn(
                        `Você não pode fazer um pedido de urgência/emergência acima de ${slaCarater} horas.`,
                        'warn'
                      );

                      if (localStorage.getItem('dataSugerida')) localStorage.removeItem('dataSugerida');

                      /* document.getElementById('dataSugerida').value = '';
                      return; */
                    }
                  } else if (values.id === this.state.caraterEletivo) {
                    slaCarater = this.state.slacaraterEletivo;
                    if (differenceInDays(dataSugerida, dataAtual) < slaCarater) {
                      this.showWarn('Data selecionada está dentro do prazo mínimo do SLA.', 'warn');

                      if (localStorage.getItem('dataSugerida')) localStorage.removeItem('dataSugerida');

                      /* document.getElementById('dataSugerida').value = '';
                      return; */
                    }
                  }
                }

                localStorage.setItem('carater', JSON.stringify(values));
                this.setState({ carater: values });

                setPendencia(1, PendenciasWizard.carater);
              }}
              renderInput={params => <TextField {...params} label="Caráter" variant="outlined" />}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id="modalidadeAtendimento"
              options={this.state.listaModalidadeAtendimento}
              getOptionLabel={option => `${option.descricao}`}
              fullWidth
              disableClearable
              value={this.state.modalidadeAtendimento}
              onChange={(e, values) => {
                if (values) this.handleAlteracaoModalidadeAtendimento(values);
              }}
              renderInput={params => (
                <TextField {...params} label="Modalidade Cirúrgica" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              select
              name="lateralidade"
              variant="outlined"
              fullWidth
              id="lateralidade"
              label="Lateralidade"
              value={this.state.lateralidade}
              onChange={e => {
                localStorage.setItem('lateralidade', e.target.value);
                this.setState({ lateralidade: e.target.value });
              }}
            >
              <MenuItem value="D"> Direita </MenuItem>
              <MenuItem value="E"> Esquerda </MenuItem>
              <MenuItem value="N"> Não se aplica </MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              multiline
              rows={5}
              rowsMax={15}
              name="indicacaoClinica"
              variant="outlined"
              fullWidth
              id="indicacaoClinica"
              label="Indicação Cirúrgica"
              value={this.state.indicacaoClinica}
              onChange={e => {
                localStorage.setItem('indicacaoClinica', e.target.value);
                this.setState({ indicacaoClinica: e.target.value });

                setPendencia(1, PendenciasWizard.indicacaoClinica);
              }}
              inputProps={{
                maxlength: 200,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id="prioridade"
              options={this.state.listaPrioridade}
              getOptionLabel={option => `${option.descricao}`}
              option
              fullWidth
              value={this.state.prioridade}
              onChange={(e, values) => {
                localStorage.setItem('prioridade', JSON.stringify(values));
                this.setState({ prioridade: values });

                setPendencia(1, PendenciasWizard.prioridade);
              }}
              renderInput={params => (
                <TextField {...params} label="Prioridade" variant="outlined" />
              )}
              renderOption={(props, option) => {
                const { descricao, cor } = option;
                return (
                  <div className="div-item-prioridade">
                    <span {...props} className="item-prioridade">
                      <span className="bolinha-prioridade" style={{ backgroundColor: cor }} />
                      {`${descricao}`}
                    </span>
                  </div>
                );
              }}
              style={{
                border: `solid ${this.state.prioridade ? this.state.prioridade.cor : ''} 1px`,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id="cidPrincipal"
              options={this.state.listaCid}
              getOptionLabel={option => `${option.codigo} - ${option.descricao}`}
              fullWidth
              value={this.state.cidPrincipal}
              onChange={(e, values) => {
                localStorage.setItem('cidPrincipal', JSON.stringify(values));
                this.setState({ cidPrincipal: values });

                setPendencia(1, PendenciasWizard.cidPrincipal);
              }}
              renderInput={params => (
                <TextField {...params} label="CID Principal" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              multiple
              id="cidsSecundarios"
              options={this.state.listaCid}
              getOptionLabel={option => `${option.codigo} - ${option.descricao}`}
              value={this.state.cidsSecundarios}
              onChange={(e, values) => {
                localStorage.setItem('cidsSecundarios', JSON.stringify(values));
                this.setState({ cidsSecundarios: values });
              }}
              filterSelectedOptions
              renderInput={params => (
                <TextField {...params} variant="outlined" label="CIDs Secundários" />
              )}
            />
          </Grid>
        </Grid>
        <br />
        {/* <Divider />
        <br />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Internação</h3>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              autoComplete="off"
              type="date"
              name="dataInternacao"
              variant="outlined"
              fullWidth
              disabled={
                (this.state.internacao && this.state.internacao.idLegado) ||
                this.state.bloqueioRecursoSistemaInternacaoPedidoCirurgia
              }
              id="dataInternacao"
              label="Data da Internação"
              InputLabelProps={{ shrink: true }}
              value={this.state.dataInternacao}
              onChange={e => {
                const dataInternacao = new Date(e.target.value);
                if (
                  isBefore(dataInternacao, new Date(this.state.dataSugerida)) &&
                  this.state.motivoAntecipacaoInternacao === null
                ) {
                  this.showWarn(
                    'É necessário informar o motivo da internação ser antecipada.',
                    'info'
                  );
                  localStorage.setItem('dataInternacao', this.formatDate(dataInternacao));
                  this.setState({ dataInternacao: this.formatDate(dataInternacao) });
                } else if (isBefore(dataInternacao, new Date(this.state.dataSugerida))) {
                  localStorage.setItem('dataInternacao', this.formatDate(dataInternacao));
                  this.setState({ dataInternacao: this.formatDate(dataInternacao) });
                } else if (isAfter(dataInternacao, new Date(this.state.dataSugerida))) {
                  this.showWarn(
                    'A data da internação não pode ser depois que a data sugerida para cirurgia!',
                    'warn'
                  );
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id="motivoAntecipacaoInternacao"
              options={this.state.listaMotivosAntecipacaoInternacao}
              getOptionLabel={option => `${option.descricao}`}
              option
              disabled={
                (this.state.internacao && this.state.internacao.idLegado) ||
                this.state.bloqueioRecursoSistemaInternacaoPedidoCirurgia
              }
              fullWidth
              value={this.state.motivoAntecipacaoInternacao}
              onChange={(e, values) => {
                localStorage.setItem('motivoAntecipacaoInternacao', JSON.stringify(values));
                this.setState({ motivoAntecipacaoInternacao: values });
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Motivo de Antecipação da Internação"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id="tipoAcomodacao"
              options={this.state.listaTipoAcomodacao}
              getOptionLabel={option => `${option.descricao}`}
              option
              fullWidth
              disabled={
                (this.state.internacao && this.state.internacao.idLegado) ||
                this.state.bloqueioRecursoSistemaInternacaoPedidoCirurgia
              }
              value={this.state.tipoAcomodacao}
              onChange={(e, values) => {
                localStorage.setItem('tipoAcomodacao', JSON.stringify(values));
                this.setState({ tipoAcomodacao: values });

                setPendencia(1, PendenciasWizard.tipoAcomodacao);
              }}
              renderInput={params => (
                <TextField {...params} label="Acomodação" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormControlLabel
              control={
                <Checkbox
                  name="checkedA"
                  id="leitoUTI"
                  disabled={
                    (this.state.internacao && this.state.internacao.idLegado) ||
                    this.state.bloqueioRecursoSistemaInternacaoPedidoCirurgia
                  }
                  checked={this.state.leitoUTI}
                  color="primary"
                  onChange={e => {
                    localStorage.setItem('leitoUTI', e.target.checked);
                    this.setState({ leitoUTI: e.target.checked });
                  }}
                />
              }
              label="Leito UTI?"
            />
          </Grid>
            </Grid> */}
        <br />
        <Divider />
        <br />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Tipo de Anestesia</h3>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id="tipoAnestesia"
              options={this.state.listaTipoAnestesia}
              getOptionLabel={option => `${option.descricao}`}
              option
              fullWidth
              value={this.state.tipoAnestesia}
              onChange={(e, values) => {
                localStorage.setItem('tipoAnestesia', JSON.stringify(values));
                this.setState({ tipoAnestesia: values });

                setPendencia(1, PendenciasWizard.tipoAnestesia);
              }}
              renderInput={params => (
                <TextField {...params} label="Tipo Anestesia" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormControlLabel
              control={
                <Checkbox
                  name="avaliacaoAnestesica"
                  disabled
                  id="avaliacaoAnestesica"
                  checked={this.state.avaliacaoAnestesica}
                  color="primary"
                  onChange={e => {
                    localStorage.setItem('avaliacaoAnestesica', e.target.checked);
                    this.setState({ avaliacaoAnestesica: e.target.checked });
                  }}
                />
              }
              label="Necessita de Avaliação Anestésica?"
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              multiline
              rows={5}
              rowsMax={15}
              disabled
              name="motivoAvaliacaoAnestesica"
              variant="outlined"
              fullWidth
              id="motivoAvaliacaoAnestesica"
              label="Motivo Avaliação"
              value={this.state.motivoAvaliacaoAnestesica}
              onChange={e => {
                localStorage.setItem('motivoAvaliacaoAnestesica', e.target.value);
                this.setState({ motivoAvaliacaoAnestesica: e.target.value });
                setPendencia(1, PendenciasWizard.motivoAvaliacaoAnestesica);
              }}
              inputProps={{
                maxlength: 65535,
              }}
            />
          </Grid>
        </Grid>
      </Container>
    );
  }
}
export default DadosSolicitacao;
